// extracted by mini-css-extract-plugin
export default {"root":"cardStock-module__root--xyWzB","noLink":"cardStock-module__noLink--x16QJ"};